import React, { useState } from "react";
import PropTypes from "prop-types";

const ChatInput = ({
  onSend,
  disabled = false,
  placeholder = "Type your message..."
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleSend = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !disabled) {
      onSend(trimmed);
      setInputValue("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="border-t border-grey-17 p-6.2">
      <div className="flex gap-3.5">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          className="flex-1 rounded-25px border border-grey-17 px-4.5 py-3.5 text-ft14-19.6
                     focus:border-transparent focus:outline-none focus:ring-2 focus:ring-navyBlue-10
                     disabled:cursor-not-allowed disabled:bg-grey-18"
        />
        <button
          onClick={handleSend}
          disabled={!inputValue.trim() || disabled}
          className={`rounded-25px px-6.2 py-3.5 font-InterMedium transition-all ${
            inputValue.trim() && !disabled
              ? "bg-green-12 text-white hover:bg-blue-4379F2"
              : "cursor-not-allowed bg-grey-17 text-grey-14"
          }`}
        >
          Send
        </button>
      </div>
    </div>
  );
};

ChatInput.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};

export default ChatInput;
